export default __webpack_public_path__ + "static/interieur.en.cover-0e8c1b3224dc1cb9d6192fb8082ffce7.jpg";